import { showSuccessAlert } from "@actions/index";
import { connect } from "react-redux";
import BaseBreakdownTab from "./BaseBreakdowTab";

class InterimCollections extends BaseBreakdownTab {
  meterGridKey = "meterGridInterim";
  detailGridKey = "detailGridInterim";
}

const mapStateToProps = (state) => {
  return {
    modal: state.collectionBreakdownModal,
  };
};

export default connect(mapStateToProps, { showSuccessAlert })(
  InterimCollections,
);
